import React from 'react';
import './Hero.css';
import heroImage from '../images/banner-take-control.png';

const Hero = () => {
    return (
        <section className="hero">
            <div className="hero-container">
                <div className="hero-content">
                    <h1>Take back control of your crypto.</h1>
                    <p>Buy, store, swap, sell, and spend your assets. All from one powerful crypto app. No centralized exchange, no excessive markups, just true control across the top chains.</p>
                    <button>Get the App</button>
                </div>
                <div className="hero-image">
                    <img src={heroImage} alt="Take back control of your crypto" />
                </div>
            </div>
        </section>
    );
};

export default Hero;